<ion-menu contentId="main-content">
  <ng-container *ngIf="customerDetails?.id; else notLoggedIn">
    <div class="profile-image">
      <div class="image">
        <img loading="lazy" [src]="profileImage" class="img" />
      </div>
      <div class="profile-detail">
        <ion-label>{{ customerDetails?.name | uppercase }}</ion-label>
      </div>
      <div class="profile-number">
        <ion-label> + {{ customerDetails?.phoneNumber }}</ion-label>
      </div>
    </div>
    <ion-content class="ion-padding">
      <div class="line-container">
        <div class="hr"></div>
      </div>
      <div class="menu">
        <ion-menu-toggle autoHide="false">
          <ion-list lines="none" class="menu-list">
            <ion-item button class="menu-item" (click)="getHome()">
              <ion-icon
                name="home-outline"
                slot="start"
                class="primary-color"
              ></ion-icon>
              <ion-label>Home</ion-label>
            </ion-item>
            <ion-item button class="menu-item" (click)="navigateToRoute('simpayx/user-profile')">
              <ion-icon
                name="person-outline"
                slot="start"
                class="primary-color"
              ></ion-icon>
              <ion-label>Profile</ion-label>
            </ion-item>
            <ion-item
              button
              class="menu-item"
              (click)="navigateToRoute('simpayx/manage-cards')"
            >
              <ion-icon
                name="card-outline"
                slot="start"
                class="primary-color"
              ></ion-icon>
              <ion-label>Saved Cards</ion-label>
            </ion-item>
            <ion-item
              button
              class="menu-item"
              (click)="navigateToRoute('simpayx/order-history')"
            >
              <ion-icon
                name="list-outline"
                slot="start"
                class="primary-color"
              ></ion-icon>
              <ion-label>Orders</ion-label>
            </ion-item>
            <ion-item
              button
              class="menu-item"
              (click)="navigateToRoute('simpayx/addresses')"
            >
              <ion-icon
                name="compass-outline"
                slot="start"
                class="primary-color"
              ></ion-icon>
              <ion-label>Manage Addresses</ion-label>
            </ion-item>
          </ion-list>
        </ion-menu-toggle>
      </div>
    </ion-content>
    <ion-menu-toggle autoHide="false">
        <div class="footer">
          <ion-item button class="menu-item" (click)="logoutAlert()">
            <ion-icon
              name="log-out-outline"
              slot="start"
              class="primary-color"
            ></ion-icon>
            <ion-label class="primary-color" style="font-weight: 700;">Logout</ion-label>
          </ion-item>
        </div>
    </ion-menu-toggle>
  </ng-container>
  <ng-template #notLoggedIn>
    <div class="ion-padding">
      <ion-menu-toggle autoHide="false">
        <ion-item
          lines="none"
          class="ion-margin-top ion-margin-bottom ion-margin-end"
          detail="true"
        >
          <div class="icon-circle">
            <ion-icon
              slot="start"
              name="home-outline"
              class="primary-color"
            ></ion-icon>
          </div>
          <ion-label> Home </ion-label>
        </ion-item>
        <ion-item
          lines="none"
          class="ion-margin-top ion-margin-bottom ion-margin-end"
          detail="true"
          (click)="navigateToRoute('simpayx/login')"
        >
          <div class="icon-circle">
            <ion-icon
              slot="start"
              name="log-in-outline"
              class="primary-color"
            ></ion-icon>
          </div>
          <ion-label> Login </ion-label>
        </ion-item>
      </ion-menu-toggle>
    </div>
  </ng-template>
</ion-menu>
